module.exports = __webpack_public_path__ + "img/grand-vitara-boostergreen.1a6501db.png";